module.exports = __webpack_public_path__ + "img/bg7-copy.8242ab0d.jpg";